export const PageDataState = {
    Searchs: {
        course_eb_01_id: {
            type: 'text',
            id: 'course_eb_01_id',
            label: '',
            value: '',
        },
        topic: {
            type: 'text',
            id: 'topic',
            label: 'หัวข้อ',
            value: '',
            placeholder: 'หัวข้อ',
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        course_eb_01_id: {
            type: 'select',
            id: 'course_eb_01_id',
            label: 'หลักสูตร EB-01',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        topic: {
            type: 'textarea',
            rows: 3,
            id: 'topic',
            label: 'หัวข้อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        outcome: {
            type: 'textarea',
            rows: 3,
            id: 'outcome',
            label: 'outcomes ที่เกี่ยวข้อง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        theory_time: {
            type: 'text',
            id: 'theory_time',
            label: 'ระยะเวลา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },     
        workshop_time: {
            type: 'text',
            id: 'workshop_time',
            label: 'ระยะเวลา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },                       
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        }      
    },
    InputGroup: {}
}